import Backbone from 'backbone';


export default Backbone.Model.extend({
  // Backbone doesn't think the item exists on the server without an ID
  idAttribute: 'url',
  url: function () {
    return this.get('url') || this.collection.url;
  }
});



// WEBPACK FOOTER //
// ./static/js/models/permission.js